        import { Component ,OnInit} from '@angular/core';
        import * as firebase from 'firebase';
import { Router} from '@angular/router';

        @Component({
          selector: 'app-root',
          templateUrl: './app.component.html',
          styleUrls: ['./app.component.css']
        })
        export class AppComponent implements OnInit {

    constructor(private router:Router) { }
        ngOnInit() {
        firebase.initializeApp({

         apiKey: "AIzaSyC6c9o8Nyn69jmwUbj_6FVM2CqMpkz_Trk",
            authDomain: "ng-http-17494.firebaseapp.com"
        });  
        }

        loadedFeature='feedback';

        onNavigate(feature:string)
        {
        this.loadedFeature = feature;
        }



          public onLoginClick(){
        this.router.navigate(['interview']);
    }


}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/app.component.ts